<template>
    <div class="page-next-button">
        <div class="page-next-button__btn" v-on:touchstart="clickHandler" v-on:click="clickHandler">
            <div class="page-next-button__label">Verder</div>
            <i class="page-next-button__image fa fa-arrow-down" aria-hidden="true"></i>
        </div>
    </div>
</template>
<style lang="stylus">
    @require "../../styles/variables.styl";

    .page-next-button
        text-align center
        margin 30px 0

    .page-next-button__label
        font-family $font-button


    .page-next-button__btn
        cursor pointer

    .page-next-button__image
        font-size 2em
</style>
<script>
    export default{
        methods: {
            clickHandler() {
                this.$emit('click');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// page-next-button.vue?41a8c911